import { createContext, useContext } from 'react';
import { AppData } from '../types/core';
import { PortSelectItem } from '../types/port';
import { Island } from '../types/island';

export interface AppDataContextValue {
  appData: AppData;
  islands: Island[];
  ports: PortSelectItem[];
  portsMap: Record<string, PortSelectItem>;
  refetchIslandAndPortData: () => void;
  isFetching: boolean;
}

const AppDataContext = createContext<AppDataContextValue>({
  appData: {
    contractStatus: [],
    contractInsuranceCoverageTypes: [],
    counties: [],
    countries: [],
    crewMemberCertificateStatus: [],
    crewMemberNoteType: [],
    crewMemberRole: [],
    crewMemberStatus: [],
    errorType: [],
    fuelTypes: [],
    journeyNoteTypes: [],
    entityStatus: [],
    journeyStatus: [],
    journeyReliefEventType: [],
    routeStatus: [],
    serviceTypes: [],
    vesselCertificateStatus: [],
    vesselCertificateTypes: [],
    vesselInsuranceCoverageTypes: [],
    vesselNoteTypes: [],
    vesselStatus: [],
  },
  islands: [],
  ports: [],
  portsMap: {},
  refetchIslandAndPortData: () => {},
  isFetching: false,
});

export default AppDataContext;

export const useAppDataContext = () => useContext(AppDataContext);
